export type WorkspaceStoreState = {
  fields: any;
};

export const initialState: WorkspaceStoreState = {
  fields: {},
};
